import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';

import Icon from 'shared/modules/common/components/atoms/Icon';
import url from 'shared/modules/common/constants/url';

type OTPVoiceCallContainerProps = {
  onVoiceCallInvoke: () => void;
};

const COUNTDOWN_LENGTH = 30;

const OTPVoiceCallContainer = ({
  onVoiceCallInvoke,
}: OTPVoiceCallContainerProps) => {
  const [countdownTick, setCountdownTick] = useState(COUNTDOWN_LENGTH);
  const [isVoiceCallInvoked, setIsVoiceCallInvoked] = useState(false);

  useEffect(() => {
    let timer: number;

    if (countdownTick) {
      // https://github.com/Microsoft/TypeScript/issues/30128#issuecomment-807394387
      timer = +global.setTimeout(() => {
        setCountdownTick(countdownTick - 1);
      }, 1000);
    }

    return () => clearTimeout(timer);
  });

  const onClickUseVoiceCall = () => {
    setCountdownTick(COUNTDOWN_LENGTH);
    setIsVoiceCallInvoked(true);
    onVoiceCallInvoke();
  };

  return (
    <View style={style.faqContainer}>
      <View style={style.faqTitle}>
        <Icon name="help-sms" size="24" style={style.icon} />
        <Text style={style.faqTitleText}>
          {!isVoiceCallInvoked && countdownTick > 0
            ? `${countdownTick}秒以内にSMSが届かない場合`
            : 'SMSが届いていませんか？'}
        </Text>
      </View>
      <Text style={style.itemText}>下記のいずれかをお試しください。</Text>
      <View style={style.faqItem}>
        <Icon name="bullet-black" size="24" style={style.icon} />
        <TouchableOpacity
          disabled={
            (!isVoiceCallInvoked && countdownTick > 0) ||
            (!!isVoiceCallInvoked && countdownTick > 0)
          }
          onPress={onClickUseVoiceCall}
          style={style.voiceCall}
        >
          <Text
            style={[
              style.itemText,
              !isVoiceCallInvoked && countdownTick > 0
                ? style.disabledLink
                : !!isVoiceCallInvoked && countdownTick > 0
                ? style.disabledLinkGray
                : style.primaryLink,
            ]}
          >
            {!isVoiceCallInvoked && countdownTick > 0
              ? '自動音声案内で認証コードを受け取ることができるようになります'
              : '自動音声案内で認証コードを受け取る'}
          </Text>
        </TouchableOpacity>
      </View>
      <View style={style.faqItem}>
        <Icon name="bullet-black" size="24" style={style.icon} />
        <Text style={style.itemText}>
          {`よくあるご質問の「`}
          <TouchableOpacity accessibilityRole="link" href={url.smsFaq}>
            <Text style={[style.itemText, style.primaryLink]}>
              ペイディからSMSが届きません
            </Text>
          </TouchableOpacity>
          {`」を確認してもう一度試す`}
        </Text>
      </View>
    </View>
  );
};

const style = StyleSheet.create({
  disabledLink: {
    color: '#1c1c1c',
  },
  disabledLinkGray: {
    color: '#e1e1e1',
  },
  primaryLink: {
    color: '#E52581',
    textDecorationLine: 'underline',
  },
  faqContainer: {
    marginTop: 58,
    marginLeft: 8,
    marginRight: 7,
  },
  faqTitle: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  icon: {
    marginRight: 8,
  },
  faqTitleText: {
    fontWeight: '600',
    fontSize: 14,
    lineHeight: 24,
  },
  itemText: {
    fontWeight: '300',
    fontSize: 12,
    lineHeight: 24,
  },
  faqItem: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 8,
  },
  voiceCall: {
    flex: 1,
  },
});

export default OTPVoiceCallContainer;
